module.exports = "/assets/data/a14a724039cd08283a3e3a9c69fdc8ae-AL3.data.json";